import { ReactNode } from "react";
import styles from "./Avatar.module.css";

type AvatarProps = {
  size?: "xs" | "s" | "m" | "l";
  src: string | undefined;
  fallback: ReactNode;
};

export function Avatar({ src, fallback, size = "s" }: AvatarProps) {
  return (
    <span className={styles.avatar} data-size={size}>
      {src && <img src={src} />}
      {!src && fallback && fallback}
    </span>
  );
}
